<template>
  <div class="date-filter-box">
    <div class="date-box exam-filter">
      <div class="form-floating">
        <date-picker
          id="startDate"
          :placeholder="$t('exam.from')"
          v-model="startDate"
          :locale="locale"
          value-type="date"
          :selectText="$t('select')"
          :cancelText="$t('cancel')"
          :format="$t('dateFormatFns')"
          :inputFormat="$t('dateFormatFns')"
          :enableTimePicker="false"
          :disabled-date="disabledDate"
          data-test="datePickerBaseFilterStart">
        </date-picker>
        <label for="startDate">{{ $t('exam.from') }}</label>
      </div>
    </div>

    <div class="date-box">
      <div class="form-floating">
        <date-picker
          id="endDate"
          :placeholder="$t('exam.to')"
          v-model="endDate"
          :locale="locale"
          value-type="date"
          :selectText="$t('select')"
          :cancelText="$t('cancel')"
          :format="$t('dateFormatFns')"
          :inputFormat="$t('dateFormatFns')"
          :enableTimePicker="false"
          :disabled-date="disabledDate"
          data-test="datePickerBaseFilterEnd">
        </date-picker>
        <label for="endDate">{{ $t('exam.to') }}</label>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .date-filter-box {
    display:                         flex !important;
    flex-direction:                  row;
    justify-content:                 space-evenly;
    flex-wrap:                       nowrap;
  }

  .date-box {
    position:                        relative;
    // max-width:                       191px;
    max-width:                       unset;
    margin:                          0;
    flex: 1;
  }

  @media (max-width: 991px) {
    .date-box {
      width:                         100%;
      max-width:                     unset;
    }
  }
</style>

<script>
import { useUserStore } from '@/store/user'
import { useExamFilterStore } from '@/store/examFilter';
import { enUS, ptBR, es } from 'date-fns/locale' // BEWARE this loads the datepicker translations

export default {
  name: 'BaseDateFilter',
  props: {
    internalDates: {
      type: Object,
      default: () => ({
        startDate: null,
        endDate: null
      })
    }
  },
  data: () => ({
    startDate:  null,
    endDate: null,
    session: {
      collaborator: {},
      currentClinic: {}
    },
  }),
  computed: {
    locale() {
      return this.$utils.datePickerLocale()
    }
  },
  watch: {
    startDate: function (value) {
      this.setDate()
    },
    endDate: function (value) {
      this.setDate()
    },
    internalDates: {
      deep: true,
      imediate: true,
      handler(newValue) {
        if (newValue.startDate && newValue.startDate != this.startDate)
          this.startDate = this.internalFormatDate(newValue.startDate)

        if (newValue.endDate && newValue.endDate != this.endDate)
          this.endDate = this.internalFormatDate(newValue.endDate)
      }
    }
  },
  mounted() {
    const userStore = useUserStore()
    const examFilterStore = useExamFilterStore()
    const innerFilter = examFilterStore.filter.filter
    this.session = userStore.sessionInfo

    // this.startDate = moment().subtract(3, 'month').toDate()
    // this.endDate = moment().toDate()

    if (this.$route.query.data) {
      let data = this.$utils.parseDataQuery(this.$route.query.data)

      if (data.startDate)
        this.startDate = moment(data.startDate).toDate()

      if (data.endDate)
        this.endDate = moment(data.endDate).toDate()
    }

    if (innerFilter.startDate)
      this.startDate = this.internalFormatDate(innerFilter.startDate)

    if (innerFilter.endDate)
      this.endDate = this.internalFormatDate(innerFilter.endDate)
  },
  methods: {
    disabledDate(date) {
      const today = moment();
      return date > today
    },
    setDate() {
      let filterDate = {
        startDate: this.$utils.formatDate(this, this.startDate),
        endDate: this.$utils.formatDate(this, this.endDate)
      };
      this.$emit('change-date', filterDate);
    },
    internalFormatDate(date) {
      return moment(date, this.$i18n.t('dateFormat')).toDate()
    }
  },
  destroyed() {
    let currentDate = new Date();
    this.startDate = this.endDate.setMonth(this.endDate.getMonth() - 3);
  }
}
</script>
